const replacements: { [key: string]: string } = {
  company: 'empresa',
  customer: 'cliente',
  supplier: 'fornecedor',
  employee: 'funcionário',
  accessory: 'acessório',
  area: 'área',
  'bank account': 'conta bancária',
  consumable: 'insumo',
  'cost center': 'centro de custo',
  'document type': 'tipo de documento',
  insurer: 'seguradora',
  'plan account': 'plano de conta',
  vehicle: 'veículo',
  task: 'serviço',
  part: 'peça',
  'work order': 'orçamento',
  purchase: 'compra',
  ncm: 'ncm',
  diagnostic: 'diagnóstico',
  sale: 'venda',
  'account payable': 'contas a pagar',
  'account receivable': 'contas a receber',
  invoice: 'nota fiscal',
  quotation: 'cotação',
  'stock correction': 'correção de estoque',
  'banking entries': 'lançamento bancário',
  inventory: 'inventário',
  checklist: 'checklist',
  'material delivery': 'entrega de materiais',
  'material return': 'devolução de materiais',
  // Traduzindo o resto da mensagem
  'Failed to delete: ': 'Falha ao excluir: ',
  'is binded by': 'possui vínculo com',
  activity: 'agendamento',
  This: '',
};

export default function replaceWords(text: string): string {
  let replacedText = text;
  for (const [key, value] of Object.entries(replacements)) {
    const regex = new RegExp(`\\b${key}\\b`, 'gi'); // \b para combinar apenas palavras inteiras
    replacedText = replacedText.replace(regex, value);
  }
  return replacedText;
}
